
      import { App } from "./demo-app/app";

      App.create({});
    